export default class HomeCardModel {
  constructor({
    card: {
      title,
      description,
      date,
      proposed_by: suggestedBy,
      thumbnail,
      link: url,
      is_external_link: externalLink,
      type,
    },
    area,
  }) {
    this.title = title;
    this.description = description;
    this.date = date;
    this.url = url;
    this.externalLink = externalLink;
    this.thumbnail = thumbnail;
    this.suggestedBy = suggestedBy;
    this.area = area;
    this.type = type;
  }

  getSuggestedBy() {
    return this.suggestedBy;
  }

  getPublicationDate() {
    return this.date ? new Date(this.date * 1000).toLocaleDateString() : '';
  }

  getTitle() {
    return this.title;
  }

  getDescription() {
    return this.description?.length > 83
      ? `${this.description.slice(0, 83)}...` : this.description;
  }

  isExternalLink() {
    return this.externalLink;
  }

  getUrl() {
    return this.url;
  }

  isFolderType() {
    return this.type === 'folder';
  }

  getFolderImage() {
    return this.image || this.thumbnail || '';
  }

  getThumbnail() {
    return this.thumbnail || '';
  }

  hasLocal() {
    return this.area !== 'national';
  }

  getButtonLabel() {
    return this.externalLink ? `Lire sur ${this.suggestedBy}` : "Lire l'article";
  }
}
